import type { ContactPerson } from '@features/contacts/types/contactPerson'
import { joinPersonName } from '@features/contacts/utils/joinPersonName'

import type { AdditionalContactPersonFormValues, SupplierFormValues } from '../types/supplierForm'
import { getPrimaryContactPerson } from './supplierForm'

const isFilledAdditionalContactPerson = ({
  contactPersonId,
  email,
  firstName,
  lastName,
}: AdditionalContactPersonFormValues) =>
  Boolean(contactPersonId) || Boolean(email.trim()) || Boolean(firstName.trim()) || Boolean(lastName.trim())

// An empty row is only a placeholder for typing a new person, so it is never saved.
// `contactPersons` are the saved supplier's people, so an edited row keeps the fields the form doesn't show.
export const getAdditionalContactPersonsPayload = (
  additionalContactPersons: AdditionalContactPersonFormValues[],
  contactPersons: ContactPerson[] = [],
): ContactPerson[] =>
  additionalContactPersons
    .filter(isFilledAdditionalContactPerson)
    .map(({ contactPersonId, email, firstName, lastName }) => {
      const name = joinPersonName(firstName, lastName)

      return {
        ...contactPersons.find(({ id }) => id === contactPersonId),
        email,
        firstName,
        fullName: name,
        lastName,
        name,
      }
    })

// The detail view and other contact-person consumers read `name`/`fullName`, not firstName/lastName.
export const getPrimaryContactPersonPayload = (
  values: SupplierFormValues,
  contactPersons: ContactPerson[] = [],
): ContactPerson => {
  const name = joinPersonName(values.firstName, values.lastName)

  return {
    ...getPrimaryContactPerson(contactPersons),
    email: values.email,
    firstName: values.firstName,
    fullName: name,
    isPrimary: true,
    lastName: values.lastName,
    name,
  }
}
